<template>
  <div class="tophead">
    <div class="top" :class="!tabimg ? 'toptwo' : ''">
      <div class="top_right">
        <div class="top_right_one">
          <div
            class="cursor top_kf"
            @mouseenter="mouseover"
            @mouseleave="mouseout"
          >
            <img class="scale_img" src="@/assets/img/home/kf.png" alt="" />
          </div>
          <div class="cursor">
            <el-dropdown>
              <p class="el-dropdown-link top_kf">
                <img class="scale_img" src="@/assets/img/home/sz.png" alt="" />
              </p>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins center cursor" @click="changePassword">
                  修改密码
                </div>
                <div class="nologins center cursor" @click="signout(2)">
                  访问官网
                </div>
                <div class="nologins center cursor" @click="signout(4)">
                  查看套餐
                </div>
                <div class="nologins center cursor" @click="signout(3)">
                  隐私条款
                </div>
                <div class="nologins center cursor" @click="signout(5)">
                  删除账号
                </div>
                <div class="nologins center cursor" @click="signout(1)">
                  退出登录
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="top_right_two">
          <div class="top_right_two_r">
            <div class="top_right_two_r_img">
              <img v-if="headImgUrltop" :src="headImgUrltop" alt="" />
              <img v-else src="@/assets/img/info/tx.png" alt="" />
            </div>
          </div>
          <div class="top_right_two_text"></div>
        </div>
        <div class="top_right_she">
          <div class="">
            <p class="usname">{{ name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="buttstuts == 1 && mealType != 'FREE_DAY'"
      class="butt"
      :class="!tabimg ? 'topsher' : ''"
    >
      <div class="w100 h100 flex alcen jucen ba6e coff">
        您还没有购买套餐或套餐已过期
        <i
          style="color: #fff !important"
          class="el-icon-close cursor"
          @click="buttcilk"
        ></i>
      </div>
    </div>
    <div class="wxkf" v-if="kfStuts">
      <div class="wxkf_img">
        <img src="@/assets/img/home/kf2.png" alt="" />
      </div>
      <div class="wxkf_text">
        <p style="font-size: 16px">扫描侧方二维码，联系客服</p>
        <p>或发送邮件至</p>
        <p>business@foshobrands.com</p>
      </div>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDig"
      width="450px"
      :modal="false"
    >
      <div>
        <el-form
          ref="formPw"
          :model="formPw"
          :rules="rulesPw"
          label-width="120px"
        >
          <el-form-item label="原密码" prop="password">
            <el-input
              type="password"
              show-password
              v-model="formPw.password"
              style="100%;height:40px"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              type="password"
              show-password
              v-model="formPw.newPassword"
              style="100%;height:40px"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="againPassword">
            <el-input
              type="password"
              show-password
              v-model="formPw.againPassword"
              style="100%;height:40px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDig = false">取 消</el-button>
        <el-button type="primary" @click="handleChangePw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { GETURLBYID } from "@/api/login";
import { QUERY, EXIT, PERMITS, RECORDS, CHANGEPASSWORD } from "../api/personal";
import { QUERYMAINPERMIT } from "../api/heder";
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formPw.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      opendes: ["4"],
      emitco: localStorage.getItem("isemitco"), // 邮箱建联选中状态
      iconStuts: true,
      iconStutstwo: true,
      kfStuts: false, // 客服状态
      kfStutstwo: false,
      isCollapse: false,
      backgeStuts: localStorage.getItem("isSelect"),
      nologin: true,
      form: {
        // 用户信息
        name: "", // 用户名
        account: "", // 账号
        headImgUrl: "", // 头像
        id: "",
      },
      name: "",
      url: process.env.VUE_APP_BASE_API,
      isactive: -1,
      headImgUrl: "",
      headImgUrltop: "",
      id: "", // 用户id
      tabimg: true,
      buttstuts: localStorage.getItem("isbutt"),
      mealType: "",
      titlestuts: false,

      passwordDig: false,
      formPw: {
        password: "",
        newPassword: "",
        againPassword: "",
      },
      rulesPw: {
        password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            min: 6,
            max: 12,
            message: "长度在 6 到 12 个字符",
            trigger: "blur",
          },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 12,
            message: "长度在 6 到 12 个字符",
            trigger: "blur",
          },
        ],
        againPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.queryInfo();
    this.backgeStuts = localStorage.getItem("isSelect");
    this.permits();
  },
  methods: {
    permits() {
      let brandsParams = {
        currentPage: 1,
        size: 10,
      };
      PERMITS(brandsParams).then((res) => {
        if (res.data.body.brands.length) {
          this.buttstuts = 2;
        } else {
          this.buttstuts = 1;
        }
        localStorage.setItem("isbutt", this.buttstuts);
      });
      RECORDS({ userId: this.id }).then((rem) => {
        if (rem.data.body) {
          this.mealType = rem.data.body.mealType;
        }
      });
    },
    buttcilk() {
      this.buttstuts = 2;
      localStorage.setItem("isbutt", this.buttstuts);
    },
    // 移入事件
    mouseover() {
      this.kfStuts = true;
    },
    // 移出事件
    mouseout() {
      this.kfStuts = false;
    },
    // 移入事件
    mouseovertwo() {
      this.kfStutstwo = true;
    },
    // 移出事件
    mouseouttwo() {
      this.kfStutstwo = false;
    },
    /**
     * queryInfo()
     * 获取登录信息
     */
    queryInfo() {
      QUERY().then((res) => {
        // debugger
        if (res.data.code == "nolog") {
          this.nologin = false;
          this.$router.push("./");
        } else if (res.data.code == "forceout") {
          this.nologin = false;
          localStorage.removeItem("token");
        } else {
          this.nologin = true;
          this.form.name = res.data.body.name;
          this.form.account = res.data.body.account;
          this.form.id = res.data.body.id;
          this.id = res.data.body.id;
          this.form.headImgUrl = res.data.body.headImgUrl;
          this.name = res.data.body.name;
          this.headImgUrl = res.data.body.headImgUrl;
          this.headImgUrltop = res.data.body.headImgUrl;
          localStorage.setItem("id", res.data.body.id);
        }
      });
    },
    /**
     * signout()
     * 退出登录
     */
    signout(e) {
      if (e == 1) {
        EXIT().then((res) => {
          if (res.data.code == "error") {
            this.$message.error(res.data.msg);
          } else {
            this.$bus.$emit("noLogin", false);
            localStorage.clear();
            this.$router.push("/");
          }
        });
      } else if (e == 2) {
        window.open("https://www.foshotech.cn/");
      } else if (e == 3) {
        GETURLBYID({ id: 5 }).then((res) => {
          if (res.data.code == "success") {
            window.open(res.data.body, "_blank");
          }
        });
      } else if (e == 4) {
        this.$router.push("./package");
      } else if (e == 5) {
        this.$alert("确认以继续进行删除操作。", "提示", {
          confirmButtonText: "确认",
          callback: (action) => {
            if (action === "confirm") {
              this.$bus.$emit("deleteAccount", true);
            }
          },
        });
      }
    },
    // 修改密码
    changePassword() {
      this.passwordDig = true;
      this.formPw = {};
    },
    handleChangePw() {
      this.$refs.formPw.validate((valid) => {
        if (valid) {
          let param = {
            password: this.formPw.password,
            newPassword: this.formPw.newPassword,
            againPassword: this.formPw.againPassword,
          };
          CHANGEPASSWORD(param).then((res) => {
            if (res.data.code == "success") {
              this.passwordDig = false;
              this.$message.success("修改密码成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.men_list {
  width: 96%;
}

.iclusd {
  position: absolute;
  right: 0;
}

.top_input_list {
  position: fixed;
  top: 60px;
  left: 12%;
  z-index: 9999;
  width: 450px;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);

  .list {
    width: 100%;
    padding: 0 30px;

    .contern {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e7e8f2;
    }

    span {
      color: #ccc;
      display: inline-block;
    }
  }

  .list:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}

.coff {
  color: #fff;
}

.starMarks {
  width: 26px;
  height: 26px;
  line-height: 26px;
  background: #d9dee7;
  color: #000;
  margin-left: 46px;
}

.emit {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;

  .emit_img {
    width: 30px;
    height: 100%;
    align-items: center;
    position: absolute;
    left: 10px;
    top: 0;

    // margin-top: -13px;
    .emit_img_ci {
      height: 100%;
      align-items: center;
    }

    img {
      width: 30px;
      height: 30px;
    }

    @media screen and (min-width: 1000px) and (max-width: 2000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }

    @media screen and (min-width: 2000px) and (max-width: 3000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }
  }

  .menu_list_text {
    height: 100%;
    line-height: 50px;
    margin-left: 60px;
  }

  .menu_list_text1 {
    margin-left: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303133;
  }

  .emit_icon {
    position: absolute;
    width: 18px;
    height: 100%;
    top: 12px;
    right: 0;

    i {
      display: inline;
    }
  }
}

.emits {
  height: 50px;
  width: 90%;
  display: flex;
  position: relative;
  align-items: center;

  .emit_img {
    height: 100%;
    position: absolute;
    left: 10px;
    top: 0;
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
    }

    @media screen and (min-width: 1000px) and (max-width: 2000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }

    @media screen and (min-width: 2000px) and (max-width: 3000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }
  }

  .menu_list_text {
    height: 100%;
    line-height: 50px;
    margin-left: 60px;
  }

  .menu_list_text1 {
    margin-left: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303133;
  }

  .emit_icon {
    // position: absolute;
    width: 18px;
    height: 100%;
    top: 0;
    right: 20px;

    i {
      display: inline;
    }
  }
}

.emitcolor {
  color: #be3c6e;
}

.emit_list {
  .emit_list_cen {
    height: 50px;
    // padding: 0 40px;
    padding-left: 40px;
    padding-right: 0;
    display: flex;

    .emit_list_cen_img {
      height: 100%;
      line-height: 58px;

      img {
        width: 20px;
      }
    }

    .emit_list_cen_text {
      margin-left: 10px;
      height: 100%;
      line-height: 50px;
      align-items: center;
    }
  }
}

.title_top {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5, #000);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.nologins_title {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -200px;
  background: #fff;
  border-radius: 15px;
  padding: 20px;
}

.nologins_title_icon {
  width: 100%;
  text-align: right;
  font-size: 26px;
  padding-right: 10px;

  i {
    color: #000;
  }
}

.nologins_title_img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-top: 10px;

  img {
    width: 200px;
    height: 200px;
    display: inline-block;
    margin: 0 auto;
  }
}

.nologins_title_text {
  width: 100%;
  margin-top: 20px;

  span {
    color: #ccc;
  }
}

.nologins {
  width: 170px;
  height: 50px;
  font-size: 14px;
  line-height: 50px;
}

.nologins:hover {
  background: rgba(166, 168, 191, 0.25);
}

.addclass {
  border: 1px solid;
  border-radius: 50%;
}

.tophead {
  width: 100%;
  min-width: 970px;
  position: relative;
  z-index: 999;

  .top {
    // width: 100%;
    width: calc(100% - 250px);
    height: 55px;
    background: #fff;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    right: 0;

    .top_left {
      width: 10%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 150px;
        height: 53px;
      }
    }

    .top_right {
      // width: 22%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;

      .top_right_one {
        border-left: 1px solid #e7e8f2;
        // width: 55%;
        height: 100%;
        display: flex;

        .top_right_one_img {
          position: relative;
          border-right: 1px solid #e7e8f2;

          .info {
            width: 20px;
            height: 20px;
            line-height: 20px;
            background: #be3c6e;
            color: #fff;
            font-size: 12px;
            position: absolute;
            top: 15%;
            right: 15%;
          }
        }

        .top_kf {
          width: 55px;
          height: 55px;
          border-right: 1px solid #e7e8f2;
          display: flex;
          justify-content: center;
          align-items: center;
          object-fit: cover;

          .scale_img {
            width: 50%;
            height: 50%;
            transition: 0.2s;
          }

          .scale_img:hover {
            transform: scale(1.5);
          }
        }
      }

      .top_right_she {
        height: 100%;
        width: 130px;
        display: flex;
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        i {
          position: absolute;
          font-size: 18px;
          right: -10px;
          top: 50%;
          margin-top: -9px;
        }
      }

      .usname {
        width: 150px;
        display: inline-block;
        height: 55px;
        line-height: 55px;
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .top_right_two {
        // width: 45%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .top_right_two_r {
          // width: 40%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .top_right_two_r_img {
            // width: 70%;
            width: 50px;
            height: 50px;
            padding-left: 30px;
            border-radius: 50%;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;

            img {
              width: 40px;
              height: 40px;
              // width: 100%;
              // height: 100%;
              border-radius: 50%;
              box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);
              // height: ;
            }
          }
        }

        .top_right_two_text {
          height: 100%;
          margin-left: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          div {
            width: 100%;
            height: 40%;

            p {
              height: 100%;
              line-height: 36px;
              width: 140px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }

            .p1 {
              font-size: 14px;
              color: #25233a;
              margin-bottom: 5px;
            }

            .p2 {
              font-size: 12px;
              color: #8b8c99;
            }
          }
        }
      }
    }
  }

  .butt {
    width: 100%;
    height: 50px;
    position: fixed;
    right: 0;
    bottom: 0;

    div {
      width: 100%;
      height: 100%;
      position: relative;

      i {
        position: absolute;
        right: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .toptwo {
    width: 98%;
  }

  .topsher {
    width: 98%;
    left: 2%;
  }

  .wxkf {
    width: 24%;
    height: 130px;
    background: #fff;
    position: fixed;
    top: 110px;
    right: 30px;
    z-index: 999999;
    box-shadow: 10px 2px 10px 10px rgb(244, 244, 247);
    display: flex;

    .wxkf_img {
      height: 100%;

      img {
        height: 100%;
      }
    }

    .wxkf_text {
      height: 100%;
      padding: 25px 0;
      margin-left: 20px;

      p {
        // font-weight: bold;
        font-size: 20px;
      }
    }
  }
}

.hedimg {
  width: 100%;
  text-align: center;

  .hedimg_img {
    display: inline-block;
    height: 100%;
    margin: 5px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: block;
      box-sizing: border-box;
    }

    // background: pink;
  }
}

// @media screen and (min-width: 2560px) {
.indeulist {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.indeulist:hover {
  background: #d8dee8;
}

.sclct {
  margin-top: 100px;
  position: relative;

  .sclct_div {
    width: 50%;
    text-align: left;
  }

  .sclct_title {
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .sclct_le {
    margin-bottom: 60px;

    .sclct_one {
      width: 304px;
      height: 40px;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 60px;
      letter-spacing: 0px;
      color: #707070;
      margin-right: 75px;
    }

    .add {
      width: 101px;
      height: 51px;
      line-height: 51px;
      border-radius: 5px;
      border: solid 3px #be3c6e;
      text-align: center;
    }
  }

  .sclctr_top {
    //  height: 750px;
    //  background: pink;
    .sclctr {
      width: 300px;
      height: 40px;
      line-height: 40px;
      border-bottom: 2px solid #e7e8f2;
      margin-bottom: 50px;
      position: relative;
      color: #33343d;

      .sclctr_one {
        position: absolute;
        left: 0;
      }

      .sclctr_two {
        position: absolute;
        right: 0;
      }
    }
  }
}

.com_top_xf {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  margin: 40px 0;
}

.nologin {
  width: 100%;
  display: flex;

  .nologin_img {
    width: 444px;
    height: 444px;
    border-radius: 50%;
    margin-left: 173px;
    margin-top: 207px;
    margin-right: 115px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .nologin_text {
    font-size: 50px;
    margin-top: 250px;
    height: 230px;

    .nologin_te_one {
      color: #404040;
    }
  }

  .nologin_te_two {
    width: 256px;
    height: 122px;
    background-color: #be3c6e;
    border-radius: 5px;
    border: solid 3px #be3c6e;
    color: #fff;
    line-height: 122px;
    margin-top: 100px;
  }
}

.hedimg_img {
  width: 18%;
}

.bott {
  width: 188px;
  height: 84px;
  text-align: center;
  line-height: 84px;
  background: #be3c6e;
  border-radius: 5px;
  color: #fff;
}

// .conten_box {
//   padding-left: 40px;
// }
.bcedits {
  height: 84px;
  line-height: 84px;
}

.preserve_a {
  width: 400px;
  text-align: center;
  position: absolute;
  right: -50px;
  bottom: -100px;

  span {
    display: inline-block;
    border-bottom: 1px solid #be3c6e;
  }

  .xinxin {
    color: #be3c6e;
  }
}

.personal {
  // padding-top: 100px;
  //   margin-top: 100px;
  position: fixed;
  z-index: 9;

  .w64 {
    margin-left: 64px;
  }

  .mg15 {
    margin-left: 12%;
  }

  //   width: 100%;
  //   height: 100%;
  overflow-x: hidden;
  background: #fafafd;

  .w15 {
    width: 10%;
  }

  .per_top {
    width: 100%;
    display: flex;

    .per_men_lef {
      width: 250px;
      position: fixed;
      height: 100%;
      left: 0;
      top: 0;
      box-sizing: border-box;
      // border-right: 1px solid #e6e6e6;
      z-index: 1;

      .per_men_lef_img {
        width: 100%;
        height: 69px;
        align-items: center;
        justify-content: center;

        .imgone {
          width: 130px;
          height: 47px;
        }

        .imgtwo {
          width: 42px;
        }
      }

      .per_menu_icon {
        height: 92px;
        line-height: 92px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 150px;
          height: 55px;
        }

        .per_menu_icon_two {
          width: 40px;
          height: 40px;
        }
      }

      .menu_list {
        width: 100%;
        height: 100%;
        border-radius: 0px 5px 5px 0px;
        position: relative;

        .menu_list_img {
          width: 30px;
          height: 30px;
          position: absolute;
          left: 40px;
          top: 50%;
          margin: -30px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .menu_list_text {
          // width: 100%;
          height: 100%;
          line-height: 50px;
          margin-left: 60px;
        }
      }

      .backcolor {
        background: #be3c6e;
        color: #fff;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      .menu_butt {
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        text-align: right;
        line-height: 50px;
        border-top: 1px solid #e6e6e6;

        img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .qsa {
    background: #be3c6e;
  }

  .bceditsposhn {
    position: absolute;
    right: 0;
    bottom: 50px;
  }

  .conten_box {
    // width: 100%;
    height: 100%;
    max-width: 1920px;
    min-width: 1500px;
    margin: 0 auto;
    margin-left: 12%;
    background: rgb(250, 250, 253);
    position: relative;

    .con_title {
      width: 100%;
      height: 92px;
      text-align: left;
      line-height: 92px;
      font-size: 18px;
      font-weight: 600;
    }

    .con_title_top {
      width: 95%;
      padding-bottom: 50px;
      border-bottom: 1px solid #e7e8f2;
      display: flex;
      position: relative;

      .bcedits {
        position: absolute;
        bottom: 50px;
        right: 0;
      }

      .preserve {
        width: 188px;
        height: 84px;
        text-align: center;
        line-height: 84px;
        background: #be3c6e;
        border-radius: 5px;
        color: #fff;
        position: absolute;
        right: 0;
        bottom: 50px;
      }
    }

    .details {
      width: 300px;
      height: 315px;
      background: #fff;
      // position: absolute;
      box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

      // right: 40px;
      // top: 20px;
      .con_top {
        width: 100%;
        font-size: 16px;
        margin: 20px 0;
      }

      .con_viv {
        color: #404040;
        font-size: 12px;
        margin-bottom: 20px;
        width: 100%;
      }

      .com_imh {
        width: 124px;
        height: 124px;
        border-radius: 50%;
        margin: 0 auto;
        box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .con_edit {
        width: 138px;
        height: 38px;
        background: #be3c6e;
        color: #fff;
        border-radius: 5px;
        line-height: 38px;
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }

  .conten_cutt_top {
    padding-left: 10%;
    box-sizing: border-box;
    width: 98%;

    .conten_cutt {
      // width: 90%;
      max-width: 1920px;
      min-width: 1500px;
      margin: 0 auto;
      padding-left: 30px;
      // margin-left: 10%;
    }
  }

  .com_top {
    position: relative;

    .purchase {
      min-height: 200px;
      padding: 100px 0;
    }

    .immediately {
      width: 70px;
      height: 80px;
      line-height: 135px;
      border-bottom: 2px solid #707070;
    }
  }
}

.com_form {
  width: 30%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  // width: 200px;
  width: 100%;
  height: 100%;
  // min-height: 400px;
}

.el-menu-vertical-demo[data-v-1b92c146]:not(.el-menu--collapse) {
  height: 100%;
  width: 100%;
}

.el-menu-item {
  width: 90%;
  text-align: left;
  padding: 0;
  height: 50px;
  margin: 40px 0;
}

.el-menu-item.is-active {
  color: #000;
  background: #fff;
}

.el-menu-item:hover {
  background: #fff;
}

.el-menu--collapse {
  height: 100%;
}

.el-radio-button__inner {
  background: pink;
}

/deep/.el-form-item__content {
  width: auto !important;
}
</style>
<style lang="less">
.el-menu-vertical-demo {
  border: none;
}

.down_popover {
  padding: 20px 0;
  border-radius: 5px;
  height: 250px;
  overflow: auto;
}

.personal {
  .el-radio-button__inner {
    background: #fff;
    width: 64px;
    height: 65px;
    line-height: 50px;
    border: none;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border: none;
  }

  .el-radio-button__inner {
    border: none;
  }

  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #fff;
  }

  .el-button:hover {
    background: #fff;
  }

  .el-menu-vertical-demo {
    min-height: 100%;
    width: 65px;
  }

  .el-select-dropdown__item {
    color: #000;
  }

  .el-select-dropdown__item.selected {
    color: #be3c6e;
  }

  .el-form-item__label {
    text-align: right;
  }

  .el-collapse-item__header {
    border: none;
    height: 64px;
    // background: #be3c6e;
    border-radius: 0px 5px 5px 0px;
  }

  .el-collapse {
    border: none;
  }

  .el-menu-item i {
    display: none;
  }
}

.el-submenu__title {
  padding-left: 0 !important;
  padding: none !important;
  background: #fff;
}

.el-submenu__title:hover {
  background: #fff !important;
}

.personal {
  .el-icon-arrow-down:before {
    display: none;
  }
}

.el-submenu__title {
  padding-right: 8px !important;
}

.el-submenu {
  margin: 10px 0 !important;
}

.el-menu-item {
  margin: 10px 0 !important;
}
</style>
